import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { LangContext } from '../../../App.jsx';
import { RedirectAfterSubmitForm } from '../../../hoc/RedirectAfterSubmitForm.jsx';
import { renderField } from '../../common/FormsControls.jsx';
import { dateCardExpireFormat, required } from '../../../../_utils/validators';
import { getMethodList } from '../../../actions/payment-data';
import normalizeDate from './normalizeDate';
import validate from './validate';


const PaymentDataForm = (props) => {
  const lang = useContext(LangContext);
  const listView = `/${ lang }/my/settings/payment-data/`;

  const { anyTouched, invalid, submitting, change, handleSubmit, initialValues } = props;
  const [methods, setMethods] = useState([]);
  const [cardExpireVisible, setCardExpireVisible] = useState(false)

  useEffect(() => {
    props.getMethodList().then(response => setMethods(response));
  }, []);

  useEffect(() => {
    setCardExpireVisible((initialValues && initialValues.card_expire) || false)
  }, [initialValues]);

  const handleChange = (e) => {
    if ([2, 3].includes(Number(e.target.value))){
      setCardExpireVisible(true);
    } else {
      setCardExpireVisible(false);
      change('card_expire', null);
    }
  }

  return <div>
    <Form onSubmit={ handleSubmit } className={'cabinet-form' + (anyTouched ? ' was-validate' : '')}>

      <Field component={ renderField }
             name='name'
             label={ gettext('Название') }
             placeholder={ gettext('Название') }
             helptext={ gettext('Метка, для более удобного поиска в списке ваших платежных данных .') }/>
      <Row>
        <Col xs={12} sm={6} md={4} lg={6}>
          <Field label={ gettext('Способ выплат') }
                 helptext={ gettext('Выберите предпочитаемый способ выплат.') }
                 required={ true }
                 component={ renderField }
                 validate={ [required] }
                 onChange={ handleChange }
                 element='select'
                 name='payment_method'>
            <option value={''}>{ gettext('Не выбран') }</option>
            { methods.map(s => <option value={ s.value }>{ s.label }</option>) }
          </Field>
        </Col>
        <Col xs={12} sm={6} md={8} lg={6}>
          { cardExpireVisible && <Field label={ gettext('Окончание срока действия карты') }
                                        placeholder={ '__/__' }
                                        required={ true }
                                        component={ renderField }
                                        validate={ [dateCardExpireFormat] }
                                        normalize={ normalizeDate }
                                        className='form-control__width_30'
                                        name='card_expire'/> }
        </Col>
      </Row>

      <Field label={ gettext('Платежные данные') }
             placeholder={ gettext('Номер карты, кошелька, расчетный счет или другое.') }
             helptext={ gettext('Номер карты, кошелька, расчетный счет или другое.') }
             component={ renderField }
             validate={ [required] }
             element='auto_textarea'
             name='payment_information'/>

      <div className='text-lg-right'>
        { props.cancelHidden || <Link className='btn btn-outline-secondary mr-2 mt-2 mt-md-0' to={ listView} >
          { gettext('Отменить') }
        </Link> }
        <Button variant="primary" type="submit" disabled={ submitting || invalid } className='mr-2 mt-2 mt-md-0'>
          { gettext('Сохранить') }
        </Button>
      </div>
    </Form>
  </div>
};

PaymentDataForm.PropTypes = {
  anyTouched: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,

  getMethodList: PropTypes.func.isRequired,
}

export default compose(
  connect(null, { getMethodList }),
  RedirectAfterSubmitForm,
  reduxForm({
    form: 'paymentDataForm',
    enableReinitialize: true,
    validate
  }),
)(PaymentDataForm);
